import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";

class ShareEntryWithSNSForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
					ttSNSIconSize: 'big',
					ttSNSIconAlignment: 'left'
                },
                validated: true
            })
        }
    }

    @autobind
	handleChangeIconSize(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
				ttSNSIconSize: {
                    $set: item.value
                },
            }
        }))
    }

	@autobind
	handleChangeIconAlign(item) {
		const { onChange, data } = this.props
		onChange(update(data, {
			setting: {
				ttSNSIconAlignment: {
					$set: item.value
				},
			}
		}))
	}

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin11">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

				<div className="info_plugin">
					<div className="item_set item_sub">
						글보내기 버튼은

						<TSelectForm className="opt_set opt_plugin1" items={[
							{ label:'아이콘+문구형', value:'big' },
							{ label:'아이콘형', value:'small' },
						]} selected={data.setting.ttSNSIconSize} onSelect={this.handleChangeIconSize}/>
						형태로 표시되며

						<TSelectForm className="opt_set opt_plugin2" items={[
							{ label:'왼쪽', value:'left' },
							{ label:'가운데', value:'center' },
							{ label:'오른쪽', value:'right' },
						]} selected={data.setting.ttSNSIconAlignment} onSelect={this.handleChangeIconAlign}/>
						정렬합니다.
					</div>
				</div>
                {this.props.saveButton()}
            </div>
        )
    }
}

ShareEntryWithSNSForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default ShareEntryWithSNSForm
